// extracted by mini-css-extract-plugin
export default {"popup":"welcomePopup_popup__GylY+","wrapper":"welcomePopup_wrapper__R2LRY","footer":"welcomePopup_footer__yVfLE","closeBtns":"welcomePopup_closeBtns__sz46-"};